require('./brokerCustomProductLoader.scss');

const PropTypes = require('prop-types');
const React = require('react');
const { connect } = require('react-redux');

const { BoxTabs } = require('commonsComponents/boxTabs');
const { ContentBox } = require('commonsComponents/contentBox');

// @actions
const BrokerLandingLoaderActions = require('actions/brokerLandingLoader');
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @helpers
const { formatText } = require('core/i18n').i18n;

class BrokerCustomProductLoader extends React.Component {
    constructor(props) {
        super(props);
        this.onTabChange = this.onTabChange.bind(this);
    }

    componentWillUnmount() {
        this.props.resetActiveTab()
    }

    onTabChange(value) {
        this.props.setActiveTab(value);
        this.props.pageName && taggingEventHandled(this.props.pageName, value ? 'sliderContracts' : 'sliderProducts');
    }

    render() {
        const {
            immBrokerLandingLoader,
        } = this.props;

        const activeTab = immBrokerLandingLoader.get('activeTab');

        const tabsNav = (
            <BoxTabs
                tabs={[
                    formatText('broker-myInvestmentsProducts'),
                    formatText('broker-myInvestmentsContracts')
                ]}
                activeTab={activeTab}
                handleSelectedTab={this.onTabChange}
                defaultTabIndex={0}
                tabsAsPills={true}
            />
        );

        return (
            <div className="broker-custom-product-loader__wrapper">
                <ContentBox>
                    <div className="row">
                        <div className="broker-custom-product-loader__left-content col-md-5">
                            {tabsNav}
                        </div>
                    </div>
                </ContentBox>
            </div>
        );
    }
}

BrokerCustomProductLoader.propTypes = {
    setActiveTab: PropTypes.func,
    resetActiveTab: PropTypes.func.isRequired,
    immBrokerLandingLoader: PropTypes.object.isRequired,
    pageName: PropTypes.string
};

module.exports.constructor = BrokerCustomProductLoader;
module.exports.BrokerCustomProductLoader = connect(
    state => ({
        immBrokerLandingLoader: state.brokerLandingLoader,
    }),
    {
        setActiveTab: BrokerLandingLoaderActions.setActiveTab,
        resetActiveTab: BrokerLandingLoaderActions.resetActiveTab
    }
)(BrokerCustomProductLoader);